import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../../global/button/Button'
import { Text } from '../Typography/Typography'
import { Modal } from '../v2/Modal'
import { ModalProps } from '../v2/Modal/types'

interface ConfirmationModalProps extends ModalProps {
  onGuideClose(): void
}

export const GuideConfirmationModal: React.FC<ConfirmationModalProps> = (props) => {
  const { onGuideClose, onClose } = props

  const { t } = useTranslation()

  return (
    <Modal.Action
      title={t('Close Quick Guidelines')}
      renderFooter={({ onClose }) => [
        <Button appearance='secondary' onClick={onClose}>
          {t('Cancel')}
        </Button>,
        <Button appearance='primary' onClick={onGuideClose}>
          {t('Close Guidelines')}
        </Button>,
      ]}
      onConfirm={onGuideClose}
      onClose={onClose}
    >
      <Text isParagraph>{t('You can access Quick Guidelines at anytime')}</Text>
    </Modal.Action>
  )
}
